import React, { FC } from 'react'

import { IconDocumentRtfProps } from './IconDocumentRtf.types'
import * as Styled from './styles/IconDocumentRtf.style'

import { nonThemeableRules } from '../../ruleSet'

const IconDocumentRtf: FC<IconDocumentRtfProps> = ({
  size = nonThemeableRules.defaultSize as number as IconDocumentRtfProps['size'],
  isResponsive = false,
}: IconDocumentRtfProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path d='M11.472 12.957h7.53V5.955' stroke='#fff' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
        <path
          d='M20.712 5.015a4.265 4.265 0 0 0-2.775 1.027l-5.407 4.64a4.25 4.25 0 0 0-1.485 3.233v24.93c0 2.2 1.8 4 3.48 4h18.44c2.72 0 4-1.8 4-4V5.015H20.712Z'
          stroke='#fff'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path
          d='M24.063 28.922v-5.897m-7.986 5.897v-5.897h1.72s1.72-.123 1.72 1.72c0 1.842-1.72 1.72-1.72 1.72h-1.72m6.018-3.44h3.932m-8.107 3.44 1.35 2.457m9.705 0v-5.897h2.947m-2.947 2.947h2.457'
          stroke='#EA1A1A'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconDocumentRtf
